<template>
    <div class="animated fadeIn">
        <spinner v-if="loading"/>
      <b-card>
          <div slot="header">
            <strong>Search Delivery Orders</strong>
          </div>
          <b-row>
              <b-col sm="2">
                  <b-form-group>
                      <label for="country_id">Country</label>
                      <countryLookup v-bind:url="apiCountryLookup" v-on:selected="setCountry($event)" :lookupId="filter.country_id"/>
                  </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <label for="warehiuse_id">Stock Location</label>
                  <countryLookup v-bind:url="apiWarehouseLookup" v-on:selected="setWarehouse($event)"  :q2="filter.country_id" :lookupId="filter.from_location_id"/>
                 </b-form-group>
              </b-col>
              <b-col sm="2">
                  <b-form-group>
                      <label>Sales Document Number</label>
                        <b-form-input type="text" v-model="filter.sales_doc_num"></b-form-input>
                  </b-form-group>
                </b-col>
              <b-col sm="2">
                <b-form-group>
                    <label for="date_start">Date Start</label>
                        <b-form-input type="date" v-model="filter.date_start"></b-form-input>
                </b-form-group>
              </b-col>
            <b-col sm="2">
                <b-form-group>
                    <label for="date_end">Date End</label>
                        <b-form-input type="date" v-model="filter.date_end"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group>
                    <label for="status">Status</label>
                        <b-form-select id="status" v-model="filter.delivery_status_name"
                              :plain="true"
                              :options="['','PENDING','IN-TRANSIT','DELIVERED','UNDELIVERED']"
                              value="">
                        </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <div slot="footer">
              <b-button type="submit" size="lg" variant="primary" @click="search">Search</b-button>
          </div>
      </b-card>
      <b-row v-if="getRowCount(searchResults) > 0 && !loading">
          <b-col sm="12" >
            <b-card>
                <div slot="header">
                    <strong>Search Results</strong>
                </div>
                <div class ="table-responsive">
                    <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :items="searchResults">
                      <template slot="courier_company" slot-scope ="row">
                          <b-form-group>
                            <b-form-select v-model="row.item.courier_company"
                                    :plain="true"
                                    :options="courierlist">
                            </b-form-select>
                        </b-form-group>
                      </template>
                      <template slot="delivery_number" slot-scope="row">
                        <b-form-group>
                            <b-form-input type="text" v-model="row.item.delivery_number"></b-form-input>
                        </b-form-group>
                      </template>
                      <template slot="delivery_status_name" slot-scope = "row">
                        <b-form-group v-if="row.item.current_status == 'PENDING'">
                            <b-form-select v-model="row.item.delivery_status_name"
                                    :plain="true"
                                    :options="pstatusList">
                            </b-form-select>
                        </b-form-group>
                        <b-form-group v-if="row.item.current_status == 'IN-TRANSIT'">
                            <b-form-select v-model="row.item.delivery_status_name"
                                    :plain="true"
                                    :options="istatusList">
                            </b-form-select>
                        </b-form-group>
                        <b-form-group v-if="row.item.current_status == 'DELIVERED'">
                            <b-form-select v-model="row.item.delivery_status_name"
                                :plain="true"
                                :options="dstatusList">
                            </b-form-select>
                        </b-form-group>
                        <b-form-group v-if="row.item.current_status == 'UNDELIVERED'">
                            <b-form-select v-model="row.item.delivery_status_name"
                                    :plain="true"
                                    :options="ustatusList">
                            </b-form-select>
                        </b-form-group>
                      </template>
                      <template slot ="pod_date" slot-scope = "row">
                        <b-form-group>
                              <b-form-input type="date" v-model="row.item.pod_date"></b-form-input>
                      </b-form-group>
                      </template>
                    </b-table>
                </div>
                <div slot = "footer">
                  <b-button type="submit" size="lg" variant="primary" @click="confirmUpate">Update</b-button>
                  &nbsp;
                  <b-button type="submit" size="lg" variant="danger" @click="confirmCancel">Cancel</b-button>
                </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-else-if="noResults" >
              <b-col sm="12">
                <div align="center">
                  <strong>No Delivery Orders Found</strong>
                </div>                    
              </b-col>
        </b-row>
        <b-modal v-model="modalShow" @ok="update"  title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
          <p style="color:darkblue">Confirmed Update?</p>
      </b-modal>
      <b-modal v-model="modalCancelShow" @ok="cancel"  title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
          <p style="color:darkblue">Confirmed Cancel?</p>
      </b-modal>
      <b-modal ref="myModalRef" hide-header-close hide-footer title="POD Update" centered header-bg-variant="success" no-close-on-backdrop no-close-on-esc>
              <div class="d-block text-center">
                  <p>Status Updated.</p>
              </div>
                  <b-btn class="float-right" variant="outline-danger" @click="hideModal">Ok</b-btn>
      </b-modal>
      <b-modal ref="myErrorModalRef" hide-header-close hide-footer title="Invalid Entries" centered header-bg-variant="danger" no-close-on-backdrop no-close-on-esc>
              <div class="d-block text-center">
                  <p style="color:red">{{errorMessage}}</p>
              </div>
                  <b-btn class="float-right" variant="danger" @click="hideErrorModal">OK</b-btn>
      </b-modal>
    </div>
</template>
<script>
import axios from 'axios'
import spinner from '@/components/Spinner.vue'
import countryLookup from '@/components/Autocomplete.vue'
import {authHeader, apiCountryLookup,apiWarehouseLookup,apiPodUpdate,apiPodSearch,apiCourierLists} from '@/functions/common.vue'
export default
{
  components:{spinner,countryLookup},
    props: {
      caption: 
      {
        type: String,
        default: 'Table'
      },
      hover: 
      {
        type: Boolean,
        default: false
      },
      striped: 
      {
        type: Boolean,
        default: false
      },
      bordered: 
      {
        type: Boolean,
        default: false
      },
      small: 
      {
        type: Boolean,
        default: false
      },
      fixed: 
      {
        type: Boolean,
        default: false
      }
    },
    created()
    {
      console.log(apiCourierLists)
      axios.post(apiCourierLists, {},authHeader())
                .then (res => {
                    if(res.data.code == 1)
                    {
                      this.courierlist = res.data.data
                    }
                    console.log(res.data.data)
                })
                .catch(error => alert(error))
    },
    data: () => {
      return {
        apiCountryLookup:apiCountryLookup,
        apiWarehouseLookup:apiWarehouseLookup,
        modalShow:false,
        errorMessage:'',
        successMessage:'',
        modalCancelShow:false,
        loading: false,
        courierlist:[],
        pstatusList:['PENDING','IN-TRANSIT','DELIVERED','UNDELIVERED'],
        istatusList:['IN-TRANSIT','DELIVERED','UNDELIVERED'],
        dstatusList:['DELIVERED','UNDELIVERED'],
        ustatusList:['DELIVERED','UNDELIVERED'],
        noResults: false,
        filter: 
          {
            country_id: '',
            from_location_id:'',
            sales_doc_num:'',
            date_start: '',
            date_end: '',
            delivery_status_name:'PENDING'
          },  
        searchResults: [],
        searchResultsFields: 
        [
          {key: 'from_location_id', label: 'WH'},
          {key: 'do_info',label:'DO'},
          {key: 'invoice_nums' ,label: 'Invoices'},
          {key: 'member_full' ,label: 'IBO / Stockist'},
          {key: 'courier_company' ,label: 'Courier'},
          {key: 'delivery_number' ,label: 'Delivery #'},
          {key: 'delivery_status_name' ,label: 'Status'},
          {key: 'pod_date' ,label: 'POD Date'}
        ],
        currentPage: 1,
        perPage: 30,
        totalRows: 0,
        noResults: false
      }
    },
    methods:
    {
      setWarehouse(obj)
      {
          var id

          if (obj !== null)
          {
              id = obj.id
          } 
          else
          {
              id = ""
          }
          
          this.filter.from_location_id = id
      },
      setCountry(obj)
      {
          var id

                if (obj !== null)
                {
                    id = obj.id
                } 
                else
                {
                    id = ""
                }
          
                this.filter.country_id = id
      },
      update()
      {
        this.loading = true
        axios.post(apiPodUpdate,this.searchResults, authHeader())
           .then (res => { 
              var r = res.data
              this.loading = false
                if (r.code == 1)
                {
                  this.$refs.myModalRef.show()
                  this.search()
                }
                else
                {
                  this.errorMessage = "Changes not detected"
                  this.$refs.myErrorModalRef.show()
                }
                        
                })
            .catch(error => alert(error))

      },
      cancel()
      {
        this.search()
      },
      confirmUpate()
      {
        this.modalShow = true
      },
      confirmCancel()
      {
        this.modalCancelShow = true
      },
      getRowCount (items) 
      {
        return items.length
      },
      hideModal () 
      {
          this.$refs.myModalRef.hide()
      },
      hideErrorModal()
      {
          this.$refs.myErrorModalRef.hide()
      },
      search()
      {
          this.loading = true
          var sf = 
          {
            country_id:this.filter.country_id,
            from_location_id:this.filter.from_location_id,
            sales_doc_num:this.filter.sales_doc_num,
            from_date:this.filter.date_start,
            to_date:this.filter.date_end,
            delivery_status_name:this.filter.delivery_status_name
          }

          axios.post(apiPodSearch, sf,authHeader())
            .then (res => 
            {
                return res
            })
            .then (data =>
            {
                const resultArray = []
                const myData = data.data.data
                for (let key in myData)
                {
                    var date = myData[key].do_date
                    var member_full = myData[key].old_member_id + '<br/>'+myData[key].member_name
                    myData[key].member_full = member_full
                    var date = new Date(date);
                    var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                    myData[key].do_date=result
                    myData[key].do_info =myData[key].do_num +'<br/>'+ '('+myData[key].do_date+')'
                    var invoice_nums = ''
                    var invoice_num_list = myData[key].invoice_nums_list
                    let curDate = new Date()
                    curDate = curDate.toISOString().substr(0,10)
                    var currentStatus = myData[key].delivery_status_name
                    myData[key].current_status = currentStatus
                    myData[key].pod_date = curDate
                      for (let d in invoice_num_list)
                      {
                        if(invoice_num_list[d] != invoice_num_list[invoice_num_list.length-1])
                            {
                                invoice_nums = invoice_nums + invoice_num_list[d] + '<br/>'
                            }
                            else
                            {
                                invoice_nums = invoice_nums + invoice_num_list[d]
                            }
                      }
                    myData[key].invoice_nums = invoice_nums
                    resultArray.push(myData[key])
                    this.loading = false
                }
                this.searchResults = resultArray
                
                if(this.searchResults.length ==0)
                {
                    this.loading = false
                    this.noResults =true
                }
            })
            .catch(error => console.log(error)) 
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/pod/pods.vue